import Vue from "vue";
import Vuex from "vuex";

import VuexPersistence from "vuex-persist";
import base from "./modules/base";
import role from "./modules/configuration/role";
import user from "./modules/configuration/user";
import notification from "./modules/notification";
import changepassword from "./modules/account/changepassword";
import category from "./modules/category/category";
import faq from "./modules/category/faq";
import content from "./modules/content/content";
import legalDocuments from "./modules/legalDocuments";
import contentImage from "./modules/content/contentImage";
import contentAttachment from "./modules/content/contentAttachment";
import fixedDeparture from "./modules/content/fixedDeparture";
import feedback from "./modules/feedback";
import contactus from "./modules/contactus";
import inquiry from "./modules/inquiry";
import testimonials from "./modules/testimonials";
import booking from "./modules/booking";
import blog from "./modules/blog";
import fieldStaff from "./modules/fieldStaff";
import ourTeam from "./modules/ourTeam";

const debug = process.env.NODE_ENV !== "production";
const vuexPersist = new VuexPersistence({
	strictMode: debug, // This **MUST** be set to true
	storage: window.localStorage,
	reducer: (state) => ({
		base: state.base,
	}), // only save navigation module
});

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		base,
		role,
		user,
		notification,
		changepassword,
		category,
		faq,
		content,
		legalDocuments,
		contentImage,
		contentAttachment,
		fixedDeparture,
		feedback,
		contactus,
		inquiry,
		testimonials,
		booking,
		blog,
		fieldStaff,
		ourTeam,
	},
	strict: debug,
	mutations: {
		RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION, // this mutation **MUST** be named "RESTORE_MUTATION"
	},
	plugins: [vuexPersist.plugin], // debug ? [createLogger()] : []
});
